import { ReactElement } from 'react';

import { Box } from '@qwealth/qcore';

import { useAccessProtector, UseAccessProtectorProps } from 'hooks/useAccessProtector';

interface Props extends UseAccessProtectorProps {
  deniedElement?: ReactElement | null;
  children: ReactElement;
}

export const AccessProtector = ({ featureFlag, rolesAllowed, type, deniedElement, children }: Props): ReactElement | null => {
  const hasAccess = useAccessProtector({ featureFlag, rolesAllowed, type });
  if (!hasAccess) {
    return deniedElement === undefined ? <DefaultDeniedMessage /> : deniedElement;
  }
  return children;
};

const DefaultDeniedMessage = (): ReactElement => {
  return <Box margin="auto">User is not authorized to view this resource.</Box>;
};
